<app-loading *ngIf="loading" [showText]="false"></app-loading>
  <div class="text-center" *ngIf="error">
    <p class="text-body font-color--error"> Une erreur est survenue</p>
  </div>

<div *ngIf="page && !error">
    <!-- <app-button iconName="printer" (clickEvent)="print()"></app-button> -->
    <div>
      <div *ngIf="page.totalElements === 0" style="text-align: center; font-size: 0.9rem;">
          {{noResultLabel}}
      </div>
        <div *ngIf="page.totalElements > 0 && page.content.length === 0" style="text-align: center; font-size: 0.8em;">
            {{noResultLabel}} sur cette page. Revenez à une page précédente.
        </div>

        <div class="list-item " *ngFor="let element of page.content">
            <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{element:element}" ></ng-container>
        </div>
    </div>
    <app-pagination *ngIf="withPagination"
            [paginatedService]="paginatedService"
            (pageChanged)="pageChanged($event)"
            [page]="page"></app-pagination>
  </div>



